<app-three-column-template
  pageTitle="My Topics"
  [showLoader]="isLoading()"
  [show2columns]="true"
  [hasCustomMain]="true"
  [hasCustomTitle]="true">


  <div class="topics-wrapper">


    @if (!topics().length) {
      <div class="empty-state">
        <i class="icon icon-FolderSimple"></i>
        <div class="no-items">No items</div>
        <div class="no-items-desc">There are no items at the moment</div>
      </div>
    }

    @for (topic of topics(); track topic.id) {
      <div class="topic-item" [class.not-read]="!topic.isRead">
        @switch (topic.type) {
          @case (TYPES.News) {
            <app-news-section
              [newTabLink]="true"
              [noLeftMargin]="true"
              [news]="topic"/>
          }
          @case (TYPES.Publication) {
            <app-publication-card
              [newTabLink]="true"
              [noLeftMargin]="true"
              [hasDesc]="true"
              [publicationData]="topic"/>
          }
          @default {
            <app-simple-card
              [newTabLink]="true"
              [item]="topic"/>
          }
        }
      </div>

    }

    <div class="paginator-wrapper">
      <app-paginator
        (onPagination)="paginationChange($event)"
        [skip]="skip()"
        [take]="take()"
        [totalRecords]="totalRecords()"
        [actByRoute]="false"/>
    </div>

  </div>


  <div class="title-section" slot="custom-title">
    <div class="wrapper">
      <div class="title">My Topics</div>
      <div class="actions">

        @if (hasUnread()) {
          <div (click)="markAllRead()"
               class="button outline mr-16">
            <i class="icon-Check"></i>Mark all read
          </div>
        }
        <a [routerLink]="['/',HELPER.frLoc,'manage-my-topics']">
          <div class="button secondary">
            <i class="icon-SlidersHorizontal"></i>Manage topics
          </div>
        </a>
      </div>
    </div>
  </div>

  <div class="side-menu" slot="left-section">
    <div class="title">Types</div>
    <div class="types-wrapper">
      @for (item of sideMenuData(); track item.typeName) {
        <div class="type-item"
             (click)="setSelectedType(item)"
             [class.type-active]="item.typeName === $selectedType.value">
          <div class="type-name">{{ item.name }}</div>
          <div class="type-counts">
            @if (item.unreadCount) {
              <div class="type-unread-count">{{ item.unreadCount }}</div>
            }
            @if (item.totalCount) {
              <div class="type-total-count">{{ item.totalCount }}</div>
            }
          </div>
        </div>
      }
    </div>

  </div>


</app-three-column-template>
